<template>
    <div class="app-wrapper h-100">

        <transition name="fade">
            <div v-if="pageLoading" class="pageLoading">
                <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </transition>
        <div class="position-absolute w-100 h-100 d-flex align-items-start">
            <Sidebar v-if="$auth.check()" :collapse="collapse" v-on:setCollapse="setCollapse">
                <template>
                    <div class="toggle-area" @click.prevent="toggleCollapse">
                        <div class="toggle-round-top"></div>
                        <button><i class="fa fa-lg" :class="{'fa-caret-left': !collapse, 'fa-caret-right': collapse}"></i></button>
                        <div class="toggle-round-bottom"></div>
                    </div>
                </template>
            </Sidebar>

            <div class="top-menu-bar" v-if="!fullScreenPages.includes($route.name)">
                <button class="d-inline-block btn btn-basic top-menu-button" type="button" @click.prevent="toggleSidebar">
                    <i class="fas fa-bars fa-fw fa-2x" v-if="!showMobileMenu"></i>
                    <i class="fas fa-times fa-fw fa-2x" v-else></i>
                </button>
                <img src="/images/logo-white.png" alt="Leonards Studio">
            </div>

            <div id="env-banner" v-if="banner" class="alert m-0 rounded-0 border-0" style="height:36px;display:block"
            :class="{'alert-danger': app_env == 'production', 'alert-success': app_env != 'production'}">
                <i class="fa fa-exclamation-triangle mr-1"></i> ENV: {{app_env | titlecase}}
            </div>

            <main
            class="h-100"
            :class="[fullScreenPages.includes($route.name) ? 'fullscreen' : 'main',
            banner ? 'alt-position' : '',
            collapse ? 'collapsed' : '']">
                <div v-if="announcements && announcements.length > 0 && !fullScreenPages.includes($route.name)">
                    <div v-for="(announcement, index) in announcements" :key="index" class="w-100 bg-light-yellow font-lg d-flex align-items-center px-3 py-2 border-bottom">
                        <i class="fa fa-exclamation-triangle fa-lg mr-4" />
                        <div>
                            <div><b>{{ announcement.title }}</b></div>
                            <div>{{announcement.message}}</div>
                        </div>
                        <div class="ml-auto">
                            <span class="small mt-1" @click.prevent="closeAnnouncement(index)" style="cursor:pointer">
                                <i class="fa fa-times mr-2" />Dismiss
                            </span>
                        </div>
                    </div>
                </div>

                <router-view :schoolSelected="schoolSelected"></router-view>
            </main>
        </div>

    </div>
</template>

<script>
import User from './classes/Admin/User'
import Sidebar from './components/app/Sidebar'
import Announcement from './classes/Announcement'

export default {
    data() {
        return {
            collapse: false,
            banner: false,
            pageLoading: false,
            showMobileMenu: false,
            fullScreenPages: ['signup', 'login', 'forgot-password', 'password-reset', 'password-create', 'invite'],
            schoolSelected: {},
            announcements: [],
        }
    },

    mounted() {
        window.events.$on('openSidebar', this.showSidebar)
        this.setListeners()
        this.getAnnouncements();
    },

    beforeDestroy() {
        this.clearListeners()
    },

    methods: {
        getAnnouncements() {
            let _Announcement = new Announcement()
            var self = this
            this.announcements = []
            _Announcement.index().then((response) => {
                if (response.data && response.data.length > 0) {
                    self.announcements = response.data;
                }
            });
        },
        closeAnnouncement(index) {
            if (this.announcements && this.announcements.length > 0) {
                this.announcements.splice(index, 1);
            }
        },
        setCollapse(b) {
            this.collapse = b
        },
        toggleCollapse() {

            if (this.collapse)
            {
                this.collapse = false;
                return
            }

            this.collapse = true
        },
        setListeners() {
            var self = this
            window.events.$on('schoolSelected', this.selectSchool)
            window.events.$on('contractSelected', this.selectContract)
            window.events.$on('schoolRemoved', function() { self.selectSchool(null) })
            window.events.$on('contractRemoved', function() { self.selectContract(null) })
            window.events.$on('logout', this.onLogout)
        },

        clearListeners() {
            window.events.$off('schoolSelected')
            window.events.$off('contractSelected')
            window.events.$off('schoolRemoved')
            window.events.$off('contractRemoved')
        },

        consoleArt() {
            var ascii = `
            ____________....-' .d8888888bbb '-------....._
            .'          //     .d8:       :8b..---....___ \'.
            |Leonard's //  ()  d88:       :888b==========! !|
            |         //       d88:       :88b|==========| !|
            |___      \\_______'d88888888888b''----------'//|
            |   \       """"""""""""""""""""""""""""""""""/ |
            |    !...._____      .="""=.   :D     ____...!  |
            |    O              ! . :| . !   :D          :  |
            |    O              : cheese :   :D          :  |
            |    O              ! ' :D ' !   :D           '.|
            |    O               "=._.="   :D         __    |
            |.--'  '----._______________________.----'  '--.|
            '._____________________________________________.'

            `;
            console.log('%c'+ascii,"color:#1769ff")
        },

        toggleSidebar() {
            if ($(".sidebar").hasClass('slide-in')) this.hideSidebar();
            else this.showSidebar();
        },

        showSidebar() {
            $(".sidebar").addClass("slide-in");
            this.showMobileMenu = true;
        },

        hideSidebar() {
            $(".sidebar").removeClass('slide-in')
            this.showMobileMenu = false
        },

        showBanner() {
            //this.banner = this.$auth.check() && this.$auth.user().roles.includes('System Admin') && !this.fullScreenPages.includes(this.$route.name);
        },

        selectSchool(school) {
            //var schnum = localStorage.getItem('schoolSelected') ? JSON.parse(localStorage.getItem('schoolSelected'))['schnum'] : null

            /* if not school, clear schoolSelected */
            if (school === null) {
                /* sessionStorage */
                sessionStorage.removeItem('schoolSelected')
                sessionStorage.removeItem('school_id')
                sessionStorage.removeItem('school_name')
                sessionStorage.removeItem('school_location')
                sessionStorage.removeItem('contract_id')
                /* localStorage */
                localStorage.removeItem('schoolSelected')
                localStorage.removeItem('school_id')
                localStorage.removeItem('school_name')
                localStorage.removeItem('school_location')
                localStorage.removeItem('contract_id')
                return
            }

            /* set school selected */
            /* session storage */
            sessionStorage.setItem('schoolSelected', JSON.stringify(school))
            sessionStorage.setItem('school_id', school.schnum),
            sessionStorage.setItem('school_name', school.school_name),
            sessionStorage.setItem('school_location', school.street) // TODO: Update the location info
            /* local storage */
            localStorage.setItem('schoolSelected', JSON.stringify(school))
            localStorage.setItem('school_id', school.schnum),
            localStorage.setItem('school_name', school.school_name),
            localStorage.setItem('school_location', school.street) // TODO: Update the location info
        },

        selectContract(contract) {
            if (contract === null) {
                /* sessionStorage */
                sessionStorage.removeItem('contract_id')
                sessionStorage.removeItem('contractSelected')
                /* localStorage */
                localStorage.removeItem('contract_id')
                localStorage.removeItem('contractSelected')
                return
            }

            if (contract['contract_id']) contract['con_no'] = contract.contract_id
            var contractSelected = JSON.stringify(contract)
            /* session storage */
            sessionStorage.setItem('contract_id', contract['con_no'])
            sessionStorage.setItem('contractSelected', contractSelected)
            /* local storage */
            localStorage.setItem('contract_id', contract['con_no'])
            localStorage.setItem('contractSelected', contractSelected)
        },

        onLogin() {
            /* TODO: set onLogin emitter and listener */
            this.getAnnouncements()
        },

        onLogout() {
            window.cancelTokenSource.cancel('User logged out');

            localStorage.removeItem('auth-token');
            sessionStorage.removeItem('auth-token');

            this.$router.push({
                name: 'login',
                // query: { loggedOut: 'true' },
            });

            window.cancelTokenSource = axios.CancelToken.source();
        },
    },

    computed: {
        app_env() {
            return process.env.MIX_APP_ENV && typeof process.env.MIX_APP_ENV != 'undefined' ? process.env.MIX_APP_ENV : false;
        }
    },

    components: {
        Sidebar,
    },

    watch: {
        '$route.path': function(val, oldVal) {
            this.pageLoading = true;
            try {
                window.events.$emit('pageLoading');
            } catch {}

            if(oldVal) this.hideSidebar();

            this.showBanner();

            const self = this;
            this.$nextTick(function() {
                setTimeout(function() {
                    self.pageLoading = false
                }, 400);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
main {
    &.alt-position {
        margin-top: 36px;
    }
}
.fullscreen {
    width: 100%;
}

.top-menu-bar {
    position: fixed;
    background: #313334;
    z-index: 1022;
    height: 50px;
    overflow: hidden;
    width: 100%;
    display: flex;
    align-items: center;

    img {
        height: 40px;
    }

    button {
        color: white;
    }
}

#env-banner {
    position: fixed;
    z-index: 15;
    top: 50px;
    left: 0;
    right: 0;
    text-align: center;
    font-weight: bold;
    padding: 0.25rem 0;
    font-size: small;
}

.sidebar {
    z-index: 100;
    transform: translateX(-105%);
    transition: transform 0.5s ease;

    &.slide-in {
        transform: translateX(0);
    }
}


.pageLoading {
    position: fixed;
    z-index: 2000;
    height: 2em;
    width: 2em;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,0.1);
    width: 100vw;
    height: 100vh;
    padding-top: calc(50vh - 32px);
    padding-left: calc(50vw - 32px);
    pointer-events: none;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
    supported by Chrome and Opera */
}


//@include media-breakpoint-up(md) {
@media (min-width: 991.98px) {
    .main {
        padding: 0;
        width: calc(100% - 200px);
        margin-left: 200px;

        &.collapsed {
            width: calc(100% - 80px) !important;
            margin-left: 80px !important;
        }
    }

    .top-menu-bar {
        display: none;
    }

    .sidebar {
        transform: translateX(0);
        transition: none;
    }

    #env-banner {
        top: 0;
        left: 200px;
        font-size: large;
    }

    .container-fluid {
        padding: 1rem 1rem 0 1rem;
    }
}

// Page Loader
.lds-roller {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 32px 32px;
}
.lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #26aad9;
    margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
    top: 50px;
    left: 50px;
}
.lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
    top: 54px;
    left: 45px;
}
.lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
    top: 57px;
    left: 39px;
}
.lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
    top: 58px;
    left: 32px;
}
.lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
    top: 57px;
    left: 25px;
}
.lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
    top: 54px;
    left: 19px;
}
.lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
    top: 50px;
    left: 14px;
}
.lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
    top: 45px;
    left: 10px;
}

@keyframes lds-roller {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


@media print {
    .print-0 {
        display: none;
    }

    #env-banner {
        display: none !important;
    }
}
</style>
